// -----------------------------------------------------------------
// src/helpers/urlParser.js
//
// A helper class to parse URIs and present its information in a
// computer-readable fashion
//
// -----------------------------------------------------------------
"use strict";

(function() {

	/**
	 * Class Constructor
	 *
	 */
	const UrlParser = function(url) {
		// The raw request given
		this.rawRequest = url;
		// The keys (?key=value&&key2=value2)
		this.keys = [];
		// The values associated with the keys (?key=value&&key2=value2)
		this.values = {};

		// Initialize the values for the object
		initUrlParser.call(this);
	};

	/**
	 * Initialize the values of the object
	 *
	 * @return void
	 */
	function initUrlParser() {
		var explodedParams, values, self;
		self = this;
		explodedParams = this.rawRequest.split("&&");

		if (explodedParams[0] !== window.location.url) {
			explodedParams.forEach(function(param) {
				if(!_.isEmpty(param)) {
					values = param.split("=");
					self.keys.push(values[0]);
					self.values[values[0]] = values[1].split("||");
				}
			});
		}
	}

	/**
	 * Return the keys of the object
	 *
	 * @return array
	 */
	UrlParser.prototype.getKeys = function() {
		return this.keys;
	};

	/**
	 * Return the array of key => value of the object
	 *
	 * @return array[Object]
	 */
	UrlParser.prototype.getValues = function() {
		return this.values;
	};

	window.UrlParser = UrlParser;
}());